import { useState, useEffect } from 'react';
import { demoSettingsStore } from '../store/demoSettingsStore';
import { ChatCommandMapping, DelayConfiguration } from '../types/demoConsts';

export const useDemoSettingsStore = () => {
  const [commandMapping, setCommandMapping] = useState<ChatCommandMapping>(
    demoSettingsStore.getCommandMapping()
  );
  const [delayConfiguration, setDelayConfiguration] = useState<DelayConfiguration>(
    demoSettingsStore.getDelayConfiguration()
  );

  useEffect(() => {
    // Subscribe to store changes
    const unsubscribe = demoSettingsStore.subscribe(() => {
      setCommandMapping(demoSettingsStore.getCommandMapping());
      setDelayConfiguration(demoSettingsStore.getDelayConfiguration());
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    commandMapping,
    delayConfiguration,
    updateCommand: demoSettingsStore.updateCommand,
    updateDelay: demoSettingsStore.updateDelay,
    getCommandForMessage: demoSettingsStore.getCommandForMessage,
  };
};
